import { SUBSCRIPTION } from '../../interfaces/enumerables';

export const isPlanCovered = (activePlans: Record<string, boolean> | undefined, planId: SUBSCRIPTION): boolean => {
  if (!activePlans) return false;
  return Object.keys(activePlans).some((id) => Number(id) >= Number(planId) && activePlans[id]);
};
